export const kStringConstants = {
    Common: {
        errorAlertTitle: "Uh oh! Something went wrong",
        errorAlertMessage: "Please try again and contact us if the problem persists"
    }
}